import * as React from "react";

import { PageBase } from "../../../components";
import { DogHealthValidation } from "./DogHealthValidation";
import { DogTransientCharacteristicList } from "./DogTransientCharacteristics";

export interface IDogHealthProps {
  searchUnassigned: boolean;
}

export const DogHealth: React.FunctionComponent<IDogHealthProps> = ({ searchUnassigned }) => {
  return (
    <PageBase withCard={false}>
      <DogTransientCharacteristicList searchUnassignedCharacteristics={searchUnassigned} />
      <DogHealthValidation searchUnassignedCharacteristics={searchUnassigned} />
    </PageBase>
  );
};
